import axios from 'axios';
import { API_BASE_URL,BASE_URL } from '../config/config';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    if (userData) {
      const user = JSON.parse(userData);
      config.headers['X-User-ID'] = user.id;
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
export const authAPI = {
  login: (credentials) => api.post('/login', {
    username: credentials.email,
    password: credentials.password,
    device_id: credentials.device_id || 'web-app',
    deviceToken: credentials.deviceToken || 'web-token',
  }),
  
  register: (userData) => api.post('/registration', {
    firstname: userData.firstname,
    lastname: userData.lastname || '',
    email: userData.email,
    mobileno: userData.mobileno,
    gender: userData.gender,
    institute_id: userData.institute_id,
    password: userData.password,
    username: userData.email,
    type: userData.type || 'student',
    tradegroup: userData.tradegroup || 0,
    trade: userData.trade || 0,
    class_id: userData.class_id || 0,
    batch_id: userData.batch_id || 0,
    rollno: userData.rollno || '',
  }),
  
  logout: () => api.post('/logout'),
  
  getUserInfo: (id) => api.get(`/userInfo/${id}`),
  
  forgotPassword: (email) => api.post('/forgotPassword', { email }),
  
  verifyResetPin: (email, pin) => api.post('/password/verify-pin', { email, pin }),
  
  resetPassword: (email, pin, password) => api.post('/password/reset', { email, pin, password }),
  
  changePassword: (userId, currentPassword, newPassword) => api.post('/password/change', {
    user_id: userId,
    current_password: currentPassword,
    new_password: newPassword
  }),
  
  updateProfile: (userData) => {
    const formData = new FormData();
    Object.keys(userData).forEach(key => {
      if (userData[key] !== null && userData[key] !== undefined) {
        formData.append(key, userData[key]);
      }
    });
    return api.post('/profile/update', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export const quizAPI = {
  getCategories: () => api.get('/quiz/categories'),
  getTrades: (groupId) => api.get(`/trade/${groupId}`),
  generateQuiz: (data) => api.post('/ai/generate-exam', data),
  getQuestions: (filters) => api.post('/quiz/get-questions', filters),
  submitQuiz: (data) => api.post('/quiz/submit', data),
  getQuizHistory: (userId, limit = 20) => api.post('/quiz/history', { user_id: userId, limit }),
  getUserStats: (userId) => api.post('/quiz/user-stats', { user_id: userId }),
  getClasses: () => api.get('/class'),
  getBatches: () => api.get('/batches'),
  
  // Course & Test Series APIs
  getMyPurchasedCourses: (email) => api.get(`/mypurchased/${email}`),
  getParentFolders: (courseId) => api.get(`/parentfolder/${courseId}`),
  getSubFolders: (courseId, folderId) => api.get(`/subfolder/${courseId}/${folderId}`),
  getFolderContents: (courseId, folderId) => api.get(`/contents/${courseId}/${folderId}`),
  getExamDetails: (examId, userId) => api.get(`/exam/${examId}/details?user_id=${userId}`),
  getExamQuestions: (examId) => api.get(`/exam/${examId}/questions`),
};

export default api;

